export default {
  assigneesOptions(state) {
    return state.assignees.map((item) => ({
      ...item,
      name: item.name,
      value: item.slug,
    }));
  },

  getAssigneeNameBySlug: (state) => (slug) => {
    const assignee = state.assignees.find((assignee) => assignee.slug === slug);
    return assignee?.name ?? null;
  },
};
